import { createFileRoute } from '@tanstack/react-router'
import { redirectToGtmEntry } from '@/shared/lib/gtm-route-guard'

// Plans and subscriptions were replaced by pay-as-you-go credits (LP-272):
// old links land on the user's entry, where the balance and top-ups live.
export const Route = createFileRoute('/$lang/subscription/organization')({
  beforeLoad: ({ context, params }) => {
    redirectToGtmEntry(context, params)
  },
  staticData: { layout: 'full' },
})
